import { Model } from '../../api/model';

export class FileModel extends Model {

    public id: number;
    public uri: string;
    public url: string;
    public thumbnail_uri: string;
    public thumbnail_url: string;
    public original_name: string;
    public extension: string;
    public type: string;
    public user_id: number;
    public ip_address: string;

    public constructor(data?: Object, _service?) {
        super(data, _service);

        this.boot(data);

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/files/models/file.model.ts